
<template>
    <div class="center">
      <vs-dialog v-model="active">
        <template #header>
          <h4 class="not-margin">
                Editar grado
          </h4>
        </template>


        <div class="con-form"  v-if="row && row.persona">
            <p v-if="row && row.persona"><small>NOMBRE: </small><strong>{{row.persona.apellido_paterno}} {{row.persona.apellido_materno}} {{row.persona.nombres}}</strong></p>
            <p><small>MATRÍCULA: </small><strong>{{row.persona.matricula}}</strong></p>
            <form autocomplete="off">
                <label for="periodo" class="labelInput">
                    Grado
                </label>
                <vs-select :loading="loadingPeriodo" class="aqui pt-0" id="periodo" placeholder="Seleccionar Grado" :key="periodoId" v-model="periodo" :disabled="!periodos.length" autocomplete="off" >
                    <template v-if="periodos.length" autocomplete="off">
                        <vs-option v-for="option in periodos" :key="option.id"  :label="option.text" :value="option.id">
                            {{option.text}}
                        </vs-option>
                    </template>
                    <template v-else>
                        <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                        </vs-option>
                    </template>
                </vs-select>
            </form>
        </div>

        <template #footer>
            <div class="con-footer" style="display: flex; justify-content: center;">
                <vs-button danger @click="active = false">
                Cancelar
                </vs-button>
                <vs-button success @click="postEditarMatricula()">
                Aceptar
                </vs-button>
            </div>
        </template>
      </vs-dialog>
    </div>
</template>

<script>
import servicios from '../../../../../api/requests/servicios'
    export default {
        props: [
            'value',
            'row',
            'token'
        ],
        data:() => ({
            active: false,
            periodo: '',
            periodos: [],
            periodoId: (new Date()).getTime(),
            loadingPeriodo: false,
        }),
        methods:{
            async getGrupo(){
                this.loadingPeriodo = true
                try {
                    const response = await servicios.getPeriodo(this.row.programa_id)
                    this.periodos = response.data
                    this.periodoId =  (new Date()).getTime()
                    this.loadingPeriodo = false
                    this.getSelectGrupo()
                }
                catch{
                    this.loadingPeriodo = false
                }
            },
            getSelectGrupo(){
                this.periodo = this.row.atributo_id
                this.periodoId = (new Date()).getTime()
            },
            async postEditarMatricula(){
                try{
                    const formData = new FormData();
                    formData.append('atributo_id', this.periodo)
                    formData.append('_token', this.token)
                    const response = await servicios.postEditarMatricula(this.row.id, formData)
                    this.active = false
                    this.$emit('refreshTable')
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Información actualizada'
                    })
                }catch{

                }
            }
        },
        watch: {
            value (val) {
                this.active = val
            },    
            async active (val) {
                if (!val){
                    this.$emit('input', val);
                }
            },
            row(){
                this.getGrupo()
                this.getSelectGrupo()
            }
        }
    }
</script>
